import { Theme } from './theme.model';
import { Injector } from '@angular/core';
import { ThemeApiService } from '../services/theme-api.service';
import { DeviceGroup } from './device-group.model';
import { ThemeStatus } from './theme-status.model';

export class ThemeBundle {
    constructor(theme: Theme, themeStatus: ThemeStatus, private injector: Injector) {
        let months = ["January", "February", "March", "April", "May", "June", "July",
            "August", "September", "October", "November", "December"];
        this.Theme = theme;
        let sdList = theme.StartDateText == undefined || theme.StartDateText == null ? null : theme.StartDateText.split('-');
        let edList = theme.EndDateText == undefined || theme.EndDateText == null ? null : theme.EndDateText.split('-');
        if (sdList !== null && edList !== null) {
            let stDate = new Date(parseInt(sdList[2]), parseInt(sdList[1]), parseInt(sdList[0]));
            let edDate = new Date(parseInt(edList[2]), parseInt(edList[1]), parseInt(edList[0]));
            this.StartDate = stDate;//new Date(stDate.getTime() - stDate.getTimezoneOffset() * -60000);
            this.EndDate = edDate;//new Date(edDate.getTime() - edDate.getTimezoneOffset() * -60000);
            // this.themeScheduleSummary = 'Start Date - ' + this.StartDate.getDate() + ' - ' + months[this.StartDate.getMonth() - 1] + '<br/>' + 'End Date - ' + this.EndDate.getDate() + ' - ' + months[this.EndDate.getMonth() - 1]; //themeScheduleSummary.substring(0, themeScheduleSummary.lastIndexOf('<br />')); // Remove '<br />' at the end of the string

            this.themeScheduleSummary = 'Start Date - ' + sdList[0] + ' - ' + months[parseInt(sdList[1]) - 1] + '<br/>' + 'End Date - ' + edList[0] + ' - ' + months[parseInt(edList[1]) - 1]; //themeScheduleSummary.substring(0, themeScheduleSummary.lastIndexOf('<br />')); // Remove '<br />' at the end of the string
        }

        this.ThemeStatus = themeStatus;

        // let startDate = this.Theme.StartDateText.split('-');
        // let endDate = this.Theme.EndDateText.split('-');

        // this.themeScheduleSummary = 'Start Date - ' + startDate[0] + ' - ' + months[parseInt(startDate[1]) - 1] + '<br/>' + 'End Date - ' + this.EndDate.getDate() + ' - ' + months[this.EndDate.getMonth()]; //themeScheduleSummary.substring(0, themeScheduleSummary.lastIndexOf('<br />')); // Remove '<br />' at the end of the string
    }

    public Theme: Theme;
    public DeviceGroups: DeviceGroup[];
    public ThemeStatus: ThemeStatus;
    public themeScheduleSummary: string;

    public StartDate: Date;
    public EndDate: Date;

}
